const toDollarDisplay = (amount: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);

export const centsToDollarsDisplay = (cents: number): string => toDollarDisplay(Math.round(cents) / 100.0);

export const centsToNegativeDollarsDisplay = (cents: number): string => (cents === 0 ? '$0.00' : `-${toDollarDisplay(Math.round(cents) / 100.0).replace('-', '')}`);

export const centsToDollars = (num: number): number => num / 100.0;

/**
 * Formats a numeric string representing an amount in cents into a USD currency string.
 *
 * @param amount - A string representing the monetary amount in cents.
 *                 Non-numeric characters will be stripped before conversion.
 *                 If the input is invalid or null/undefined, "$0.00" will be returned.
 *
 * @returns A string formatted as USD currency (e.g., "$12.34").
 */
export const formatCurrency = (amount: string | null | undefined): string => {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Ensure `amount` is a valid string
  if (!amount) {
    return currencyFormatter.format(0); // Default to $0.00 for null, undefined, or empty input
  }

  // Remove all non-numeric characters, parse to integer, and handle invalid results
  const numericValue = parseInt(amount.replace(/\D/g, ''), 10);
  if (Number.isNaN(numericValue)) {
    return currencyFormatter.format(0); // Default to $0.00 for invalid input
  }

  // Convert cents to dollars and format as USD currency
  return currencyFormatter.format(numericValue / 100);
};
